// Copyright (c) 2017 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import {combineReducers} from 'redux';
import dealers from './dealers';
import dealersFiltered from './dealers-filtered';
import {getCombinedReducers as getCombinedMassLaborRateRequestDetailsReducers} from '../../mass-labor-rate-request-status-details/reducers';
import laborRateRequestCount from './labor-rate-request-count';
import searchFilters from './search-filters';
import selectedDealers from './dealers-selected';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    dealers,
    dealersFiltered,
    laborRateRequestCount,
    laborRateRequestDetails: getCombinedMassLaborRateRequestDetailsReducers(),
    searchFilters,
    selectedDealers
});



// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/reducers/index.js